<template>
	<v-container>
		<performance-review-templates-list :templates="templates" :is-admin="loggedInEmployee.isAdmin" @onSelection="onSelection" @onEditClicked="onEditClicked" @onDeleteClicked="onDeleteClicked" />

		<v-subheader v-show="templates === null || templates.length === 0" class="mt-3">
			No templates have been setup
		</v-subheader>

		<v-footer color="" app height="55">
			<v-spacer></v-spacer>
			<footer-add-btn v-if="loggedInEmployee != null && loggedInEmployee.isAdmin" @click="onAddTemplateClick">Add New Template</footer-add-btn>
		</v-footer>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewTemplatesList from '@/components/performanceReview/PerformanceReviewTemplatesList';

	export default {
		data() {
			return {};
		},
		components: {
			PerformanceReviewTemplatesList
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Custom Review Templates');
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				templates: 'performanceReviewTemplates/templates'
			})
		},
		methods: {
			onAddTemplateClick() {
				this.$router.push(`/prTemplates/create/`);
			},
			onSelection(id) {
				this.$router.push(`/prTemplate/${id}`);
			},
			onEditClicked(id) {
				this.$router.push(`/prTemplate/${id}/edit`);
			},
			onDeleteClicked(id) {
				const template = this.templates.find(x => x.id === id);

				if (confirm('Are you sure you want to delete this template?')) {
					this.$store.dispatch('performanceReviewTemplates/delete', template).then(
						response => {},
						error => {
							console.error('Error deleting Template');
						}
					);
				}
			}
		}
	};
</script>

<style></style>
